import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Box, Stepper, Step, StepLabel } from '@mui/material';

const ApprovalStepper = (props) => {
  const { data } = props;
  const steps = ['PM', 'VP', 'SVP'];

  const activeStep = steps.findIndex((role) => !data.approvals[role]);
  const completedSteps = steps.reduce((acc, role) => {
    acc[role] = !!data.approvals[role];
    return acc;
  }, {});

  return (
    <Stepper activeStep={activeStep === -1 ? steps.length : activeStep} alternativeLabel sx={{ width: '100%' }}>
      {steps.map((label) => (
        <Step key={label} completed={completedSteps[label]}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

const ApprovalTrackerGrid = () => {
  const columnDefs = [
    {
      headerName: 'Estimate Name',
      field: 'name',
      flex: 1,
      cellStyle: { textAlign: 'left' },
    },
    {
      headerName: 'Version',
      field: 'version',
      width: 120,
    },
    {
      headerName: 'Approval Progress',
      field: 'approvals',
      flex: 2,
      cellRenderer: ApprovalStepper,
    },
  ];

  const rowData = [
    {
      name: 'Eiger Mainline',
      version: 1,
      approvals: { PM: true, VP: false, SVP: false },
    },
    {
      name: 'Denali Extension',
      version: 3,
      approvals: { PM: true, VP: true, SVP: false },
    },
    {
      name: 'K2 Loop',
      version: 2,
      approvals: { PM: true, VP: true, SVP: true },
    },
    {
      name: 'Rainier North',
      version: 1,
      approvals: { PM: false, VP: false, SVP: false },
    },
  ];

  return (
    <Box
      className="ag-theme-alpine"
      sx={{
        height: 500,
        width: '100%',
        padding: 2,
        border: '1px solid #ccc',
        borderRadius: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        suppressCellFocus={true}
        getRowHeight={() => 80}
        getRowStyle={(params) => {
          const approvals = params.data?.approvals || {};
          if (approvals.SVP) {
            return {
              backgroundColor: '#e6f4ea',
              borderLeft: '4px solid #4caf50',
            };
          } else if (approvals.VP) {
            return {
              backgroundColor: '#fff9e6',
              borderLeft: '4px solid #fbc02d',
            };
          }
          return null;
        }}
      />
    </Box>
  );
};

export default ApprovalTrackerGrid;
